(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kyndeo-campaign-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.k3d-campaign-video[data-k3d-campaign-autoplay="true"] video';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const bindVideos = (root = document) => {
      if (reducedMotion.matches || !('IntersectionObserver' in window)) return;

      root.querySelectorAll(selector).forEach((video) => {
        if (video.dataset.k3dCampaignBound === 'true') return;
        video.dataset.k3dCampaignBound = 'true';
        video.muted = true;
        video.playsInline = true;

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !reducedMotion.matches) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        }, { rootMargin: '140px 0px', threshold: 0.3 });

        observer.observe(video);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => bindVideos(document), { once: true });
    } else {
      bindVideos(document);
    }

    document.addEventListener('shopify:section:load', (event) => bindVideos(event.target));
    reducedMotion.addEventListener('change', (event) => {
      if (event.matches) {
        document.querySelectorAll(selector).forEach((video) => video.pause());
      } else {
        bindVideos(document);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kyndeo-complete-the-fit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kyndeo-fit')) {
    customElements.define('kyndeo-fit', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.cards = Array.from(this.querySelectorAll('[data-fit-product]'));
        this.button = this.querySelector('[data-fit-add]');
        if (!this.button) return;
        this.buttonLabel = this.button.textContent;
        this.formatter = new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' });
        this.querySelectorAll('[data-fit-enhanced]').forEach((node) => { node.hidden = false; });
        this.cards.forEach((card) => {
          const selector = card.querySelector('[data-fit-variant]');
          const checkbox = card.querySelector('[data-fit-include]');
          if (!selector || !checkbox) return;
          selector.addEventListener('change', () => {
            const selected = this.selectedOption(card);
            checkbox.disabled = !selected;
            checkbox.checked = Boolean(selected);
            this.updateCard(card);
            this.updateTotal();
          }, options);
          checkbox.addEventListener('change', () => this.updateTotal(), options);
          this.updateCard(card);
        });
        this.button.addEventListener('click', () => this.addSelected(), options);
        window.addEventListener('pageshow', () => {
          window.requestAnimationFrame(() => {
            if (!options.signal.aborted) this.syncRestoredState();
          });
        }, options);
        this.syncRestoredState();
      }

      syncRestoredState() {
        if (this.busy) return;
        this.cards.forEach((card) => {
          const checkbox = card.querySelector('[data-fit-include]');
          if (!checkbox) return;
          const selected = this.selectedOption(card);
          checkbox.disabled = !selected;
          if (!selected) checkbox.checked = false;
          this.updateCard(card);
        });
        this.updateTotal();
      }

      selectedOption(card) {
        const selector = card.querySelector('[data-fit-variant]');
        if (!selector || !selector.value) return null;
        const selected = selector.tagName === 'SELECT' ? selector.selectedOptions[0] : selector;
        return selected && !selected.disabled ? selected : null;
      }

      updateCard(card) {
        const selected = this.selectedOption(card);
        if (!selected) return;
        card.querySelector('[data-fit-price]').textContent = selected.dataset.money;
        const compare = card.querySelector('[data-fit-compare]');
        compare.textContent = selected.dataset.compareMoney;
        compare.hidden = selected.dataset.onSale !== 'true';
        card.querySelector('input[name="quantity"]').value = selected.dataset.quantity || '1';
      }

      selectedItems() {
        return this.cards.flatMap((card) => {
          const checkbox = card.querySelector('[data-fit-include]');
          const selected = this.selectedOption(card);
          if (!checkbox?.checked || !selected) return [];
          return [{ id: selected.value, quantity: Number(selected.dataset.quantity || 1), price: Number(selected.dataset.price) }];
        });
      }

      updateTotal() {
        const items = this.selectedItems();
        const cents = items.reduce((total, item) => total + item.price * item.quantity, 0);
        this.querySelector('[data-fit-count]').textContent = this.dataset.selectionLabel.replace('__COUNT__', String(items.length));
        this.querySelector('[data-fit-total]').textContent = this.formatter.format(cents / 100);
        this.button.disabled = this.busy || items.length === 0;
      }

      async addSelected() {
        const items = this.selectedItems().map(({ id, quantity }) => ({ id, quantity }));
        if (this.busy || !items.length) return;
        this.busy = true;
        this.button.disabled = true;
        this.button.textContent = this.dataset.addingLabel;
        const controlStates = Array.from(this.querySelectorAll('input, select, button')).map((control) => [control, control.disabled]);
        controlStates.forEach(([control]) => { control.disabled = true; });
        this.setAttribute('aria-busy', 'true');
        const status = this.querySelector('[data-fit-status]');
        const cartLink = this.querySelector('[data-fit-cart-link]');
        status.textContent = '';
        cartLink.hidden = true;
        let failureMessage = this.dataset.errorLabel;
        try {
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items })
          });
          const result = await response.json();
          if (!response.ok || result.status) {
            if (typeof result.description === 'string' && result.description.trim()) {
              failureMessage = `${result.description} ${this.dataset.errorLabel}`;
            }
            throw new Error(failureMessage);
          }
          window.location.assign(this.dataset.cartUrl);
        } catch {
          status.textContent = failureMessage;
          cartLink.hidden = false;
        } finally {
          this.busy = false;
          controlStates.forEach(([control, disabled]) => { control.disabled = disabled; });
          this.button.textContent = this.buttonLabel;
          this.removeAttribute('aria-busy');
          this.updateTotal();
        }
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kyndeo-fall-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.k3d-fall-video[data-k3d-autoplay="true"] .k3d-fall-video__media';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const bindVideos = (root = document) => {
      if (reducedMotion.matches || !('IntersectionObserver' in window)) return;

      root.querySelectorAll(selector).forEach((video) => {
        if (video.dataset.k3dBound === 'true') return;
        video.dataset.k3dBound = 'true';
        video.muted = true;
        video.playsInline = true;

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !reducedMotion.matches) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        }, { rootMargin: '180px 0px', threshold: 0.18 });

        observer.observe(video);
      });
    };

    const initialize = () => bindVideos(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => bindVideos(event.target));
    reducedMotion.addEventListener('change', (event) => {
      if (event.matches) {
        document.querySelectorAll(selector).forEach((video) => video.pause());
      } else {
        bindVideos(document);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kyndeo-header"]) return;
  try {
    
  document.addEventListener('toggle', (event) => {
    const panel = event.target;
    if (!panel.matches('.k3d-header-search, .k3d-mobile-menu') || !panel.open) return;
    panel.closest('[data-k3d-header]').querySelectorAll('.k3d-header-search, .k3d-mobile-menu').forEach((other) => {
      if (other !== panel) other.open = false;
    });
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const header = event.target.closest('[data-k3d-header]');
    if (!header) return;
    const panel = event.target.closest('details[open]') || header.querySelector('details[open]');
    if (!panel) return;
    panel.open = false;
    panel.querySelector(':scope > summary')?.focus();
    event.preventDefault();
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.k3d-header-search[open], .k3d-mobile-menu[open]').forEach((panel) => {
      if (!panel.contains(event.target)) panel.open = false;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kyndeo-main-product"]) return;
  try {
    
  if (!customElements.get('kyndeo-product')) {
    customElements.define('kyndeo-product', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.selector = this.querySelector('[data-product-variant-selector]');
        this.classList.add('is-ready');
        this.querySelectorAll('[data-gallery-controls]').forEach((control) => { control.hidden = false; });
        this.querySelectorAll('[data-show-media]').forEach((button) => {
          button.addEventListener('click', () => this.showMedia(button.dataset.showMedia), options);
        });
        this.querySelectorAll('[data-product-details-link]').forEach((link) => {
          link.addEventListener('click', () => {
            const details = this.querySelector(link.getAttribute('href'));
            if (details) details.open = true;
          }, options);
        });
        if (this.selector) {
          this.selector.addEventListener('change', () => this.updateVariant(true), options);
          this.updateVariant(false);
        }
        this.showMedia(this.dataset.initialMedia);
        const sticky = this.querySelector('[data-sticky-atc]');
        const mainButton = this.querySelector('[data-product-submit]');
        if (sticky && mainButton && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(([entry]) => {
            sticky.classList.toggle('is-active', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
          });
          this.observer.observe(mainButton);
        }
      }

      showMedia(id) {
        const active = this.querySelector('[data-media-id="' + id + '"].k3d-product__media');
        if (!active) return;
        this.querySelectorAll('.k3d-product__media').forEach((media) => {
          const wasActive = media.classList.contains('is-active');
          media.classList.toggle('is-active', media === active);
          if (media !== active) {
            media.querySelectorAll('video').forEach((video) => video.pause());
            if (wasActive) media.querySelectorAll('iframe').forEach((frame) => { frame.src = frame.src; });
          }
        });
        this.querySelectorAll('[data-show-media]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.showMedia === id));
        });
      }

      updateVariant(updateUrl) {
        const selected = this.selector.selectedOptions[0];
        if (!selected) return;
        const available = selected.dataset.available === 'true';
        this.querySelectorAll('[data-product-price]').forEach((node) => { node.textContent = selected.dataset.price; });
        this.querySelectorAll('[data-product-compare-price]').forEach((node) => {
          node.textContent = selected.dataset.comparePrice;
          node.hidden = selected.dataset.onSale !== 'true';
        });
        this.querySelectorAll('[data-product-submit], [data-sticky-submit]').forEach((node) => { node.disabled = !available; });
        this.querySelectorAll('[data-product-submit-label]').forEach((node) => {
          node.textContent = available ? this.dataset.addLabel : this.dataset.soldOutLabel;
        });
        this.querySelectorAll('[data-sticky-variant]').forEach((node) => { node.textContent = selected.dataset.variantTitle; });
        this.querySelectorAll('[data-product-dynamic-checkout]').forEach((node) => { node.hidden = !available; });
        const quantity = this.querySelector('input[name="quantity"]');
        if (quantity) {
          quantity.min = selected.dataset.quantityMin || '1';
          quantity.step = selected.dataset.quantityStep || '1';
          if (selected.dataset.quantityMax) quantity.max = selected.dataset.quantityMax;
          else quantity.removeAttribute('max');
          if (updateUrl || !quantity.validity.valid) quantity.value = quantity.min;
        }
        if (updateUrl) {
          this.showMedia(selected.dataset.mediaId || this.dataset.defaultMedia);
          const url = new URL(window.location.href);
          url.searchParams.set('variant', selected.value);
          window.history.replaceState({}, '', url);
        }
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kyndeo-matching-sets"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-kmax-set-button]');
    if (!button) return;
    var rawIds = button.getAttribute('data-variant-ids') || '';
    var variantIds = rawIds.split(',').filter(function(id) { return id; });
    if (!variantIds.length) return;
    event.preventDefault();
    if (button.classList.contains('is-loading')) return;
    var loadingText = button.getAttribute('data-loading-text') || 'Adding set...';
    button.classList.add('is-loading');
    button.textContent = loadingText;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: variantIds.map(function(id) {
          return { id: Number(id), quantity: 1 };
        })
      })
    })
      .then(function(response) {
        if (!response.ok) throw new Error('Cart add failed');
        return response.json();
      })
      .then(function() {
        var cartUrl = button.getAttribute('data-cart-url') || '/cart';
        var discountCode = button.getAttribute('data-discount-code') || '';
        if (discountCode) {
          window.location.href = cartUrl + '?discount=' + encodeURIComponent(discountCode);
        } else {
          window.location.href = cartUrl;
        }
      })
      .catch(function() {
        window.location.href = button.href;
      });
  });

  } catch(e) { console.error(e); }
})();
})();
